// $(function () {
//   $(".md_login").md_login({
//     // 登入
//     whenClickSubmitBtn_login: (e) => {
//       console.log("點了一下一般登入按鈕");
//       // 成功登入之後
//       $(".md_login").trigger("closeLoginModal"); // 關閉 modal
//     },
//     whenClickSubmitBtn_login_IDNumber: (e) => {
//       console.log("點了一下身分證登入按鈕");
//       // 成功登入之後且沒有驗證過手機跟email
//       $(".md_login").trigger("switchContent", "typePhone");

//       // 如果已經驗證過手機跟email
//       // $(".md_login").trigger("closeLoginModal"); // 關閉 modal
//     },

//     //註冊
//     whenClickSubmitBtn_entryRegister: (e) => {
//       console.log("點了一下註冊按鈕");
//       // 點選註冊按鈕
//       $(".md_login").trigger("switchContent", ["validatePage", "switch_register"]);
//     },
//     whenClickSubmitBtn_validatePage: (e) => {
//       console.log("點了一下發送驗證碼的按鈕");
//       // 驗證成功之後
//       $(".md_login").trigger("switchContent", "registerSuccess");
//     },
//     whenClickSubmitBtn_modifyRegiterId: (e) => {
//       console.log("點了一下在修改郵件或手機，發送驗證碼的按鈕");
//       // 點選發送驗證碼
//       $(".md_login").trigger("switchContent", "modifyRegisterId_typeValidateCode");
//     },
//     whenClickSubmitBtn_modifyRegiterIdCode: (e) => {
//       console.log("點了一下在修改郵件或手機，驗證驗證碼的按鈕");
//       // 驗證成功之後
//       $(".md_login").trigger("switchContent", "registerSuccess");
//     },
//     whenClickGoToMemberCenter: (e) => {
//       console.log("點了一下在驗證成功前往會員專區的按鈕");
//       $(".md_login").trigger("closeLoginModal");
//     },

//     // 身分證登入之後的驗證
//     whenClickSubmitBtn_typePhone: (e) => {
//       console.log("點了一下身分證登入之後，申請手機的驗證碼的按鈕");
//       // 下一步
//       $(".md_login").trigger("switchContent", "typePhoneCode");
//     },
//     whenClickSubmitBtn_typePhoneCode: (e) => {
//       console.log("點了一下身分證登入之後，驗證手機驗證碼的按鈕");
//       // 驗證成功之後
//       $(".md_login").trigger("switchContent", "typeEmail");
//     },
//     whenClickSubmitBtn_typeEmail: (e) => {
//       console.log("點了一下身分證登入之後，申請電子郵件的驗證碼的按鈕");
//       // 申請發送驗證碼
//       $(".md_login").trigger("switchContent", "typeEmailCode");
//     },
//     whenClickSubmitBtn_typeEmailCode: (e) => {
//       console.log("點了一下在登入之後，驗證電子郵件驗證碼的按鈕");
//       // 驗證成功之後:
//       // (1) 回到原頁
//       $(".md_login").trigger("closeLoginModal"); // 關閉 modal
//       // (2) 如果有漏填資料(如:身分證、生日)等基本資料，回到基本資料頁
//     },

//     // 忘記密碼
//     whenClickSubmitBtn_forgotpsd_account: (e) => {
//       console.log("點了一下在忘記密碼輸入帳號，申請發送驗證碼的按鈕");
//       // 驗證成功之後
//       $(".md_login").trigger("switchContent", "forgotpsd_typeValidateCode");
//     },
//     whenClickSubmitBtn_forgotpsd_typeAccountCode: (e) => {
//       console.log("點了一下在忘記密碼輸入驗證碼，驗證驗證碼");
//       // 驗證驗證碼成功之後
//       $(".md_login").trigger("switchContent", "forgotpsd_resetPsd");
//     },
//     whenClickSubmitBtn_forgotpsd_resetPsd: (e) => {
//       console.log("點了一下在忘記密碼驗證完成後，重設新密碼的按鈕");
//       //驗證成功
//       $(".md_login").trigger("switchContent", "psdResetSuccess");
//     },
//     whenClickGoToLoginPage: (e) => {
//       console.log("點了一下在重設密碼之後，前往登入頁的按鈕");
//       $(".md_login").trigger("closeLoginModal"); // 關閉 modal
//     },

//     // 其他
//     whenClickGetNewValidateCode: (e) => {
//       // 按下重發驗證碼的按鈕
//       console.log("點了一下，重新發送驗證碼的按鈕");
//     },

//     whenClickTab: (e) => {
//       console.log("Tab 被點了一下");
//     },

//     whenCheckboxChecked_rememberMe: (e) => {
//       console.log("登入時，同意記得我");
//     },
//   });

//   $(".register").on("click", () => {
//     // $(".md_login").trigger("switchContent", "validatePage");
//     $(".md_login").trigger("openLoginModal", "entry");
//     $(".md_login").trigger("switchContent", ["entry", "switch_register"]);
//   });

//   $(".login").on("click", () => {
//     $(".md_login").trigger("openLoginModal", "entry");
//   });
//   // reward_rule 位置隨螢幕調整
//   function moveRewardRule() {
//     if ($(window).width() <= 768) {
//       $(".reward_rule").insertBefore(".reward_section .section_title");
//     } else {
//       $(".reward_rule").insertAfter(".reward_wrap");
//     }
//   }

//   // 初始執行
//   moveRewardRule();

//   // 螢幕改變時也重新判斷
//   $(window).resize(function () {
//     moveRewardRule();
//   });

//   $(".md_button").md_button({
//     whenClick: (e) => {
//       console.log("點一下");
//     },
//   });
// });
